import { useEffect } from 'react';

export function useResetErrorsOnClear(validateInput, minError, maxError, minValue, maxValue, setMinError, setMaxError) {
    useEffect(() => {
        if (validateInput && minError && !minValue?.value) {
            setMinError('');
        }

        if (validateInput && maxError && !maxValue?.value) {
            setMaxError('');
        }
    }, [validateInput, minError, maxError, minValue, maxValue, setMinError, setMaxError]);
}
